module.exports = __webpack_public_path__ + "images/download@3x.png?c4fadc3f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download@3x.png
// module id = 614
// module chunks = 7